import React from "react";

/**
 * App brand mark. Single source of truth so the icon stays consistent
 * across PublicHeader, DashboardLayout sidebar, PublicFooter and any
 * other surface that references the platform identity.
 *
 * Sizing follows Tailwind h/w utility scale (e.g. "h-6 w-6"). The icon
 * is a flat PNG with transparency — no background colour needed.
 */
export default function Logo({ className = "h-7 w-7", alt = "Appel247" }) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={`${className} object-contain select-none`}
      draggable={false}
      data-testid="app-logo"
    />
  );
}
